const spinnerStyle = {
  spinnerColor: "#FCFCFC",
  spinnerSize: "40px"
};

export default spinnerStyle;
